<template>
  <div class="home-content" :class="{ 'home-map': this.$route.name !== 'Board' }">
    <div class="home-header">
      <div class="left">
        <el-select v-if="this.$route.name !== 'Board'" v-model="formData.projectId" placeholder="请选择项目"
          @change="projectChange" clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
        <el-select v-if="this.$route.name === 'Board'" v-model="boardProjectId" placeholder="请选择项目"
          @change="projectChange" clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
        <el-date-picker class="picker" v-if="this.$route.name === 'Board'" v-model="value2" type="daterange"
          unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="monthChange" :clearable="false">
        </el-date-picker>
      </div>
      <div class="right" v-if="boardProjectId">
        <div :class="{ active: this.$route.name === 'Board' }" class="right-item" @click="changeRoute('Board')">
          <img class="right-item-img" src="../../assets/icon/home/boardon.png" alt=""
            v-if="this.$route.name === 'Board'" />
          <img class="right-item-img" src="../../assets/icon/home/boardoff.png" alt=""
            v-if="this.$route.name !== 'Board'" />
          <span class="span">看板</span>
        </div>
        <div :class="{ active: this.$route.name !== 'Board' }" class="right-item" @click="changeRoute('Map')">
          <img class="right-item-img" src="../../assets/icon/home/mapon.png" alt=""
            v-if="this.$route.name !== 'Board'" />
          <img class="right-item-img" src="../../assets/icon/home/mapoff.png" alt=""
            v-if="this.$route.name === 'Board'" />
          <span class="span">地图</span>
        </div>
      </div>
    </div>

    <div class="home-body">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      formData: {
        projectId: "",
      },
      boardProjectId: "",
      value2: [],
      startTime: "",
      endTime: "",
      tempTime: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "本周",
            onClick(picker) {
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              // 计算本周一（中国习惯，周一为一周开始）
              const day = start.getDay();
              const diff = start.getDate() - day + (day === 0 ? -6 : 1);
              const monday = new Date(start.setDate(diff));
              // 计算本周日
              const sunday = new Date(monday);
              sunday.setDate(monday.getDate() + 6);

              picker.$emit("pick", [monday, sunday]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              // 当月第一天
              const start = new Date();
              start.setDate(1);
              start.setHours(0, 0, 0, 0);
              // 当月最后一天
              const end = new Date(
                start.getFullYear(),
                start.getMonth() + 1,
                0
              );
              end.setHours(23, 59, 59, 999);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projectList;
    },
  },
  watch: {},
  created() {
    this.formData.projectId = this.$store.state.projectId;
    if (this.boardProjectId) {
      this.$event.$emit("onBoardMothenChange", this.value2);
    } else {
      this.setDefaultMonth();
      this.$event.$emit("onBoardMothenChange", this.value2);
    }
  },
  methods: {
    projectChange(val) {
      this.formData.projectId = val;
      this.$store.commit("setProjectId", this.formData.projectId);
      this.$event.$emit("onBoardProjectChange", this.formData.projectId);
    },
    monthChange(val) {
      if (!val) {
        this.setDefaultMonth();
      }
      // if(!val)
      this.$event.$emit("onBoardMothenChange", this.value2);
    },
    changeRoute(name) {
      if (name === "Map") {
        this.formData.projectId = this.boardProjectId;
        this.tempTime = this.value2;
        this.startTime = this.value2[0];
        this.endTime = this.value2[1];
        this.$router.replace({
          name: name,
          query: {
            projectId: this.formData.projectId,
            startTime: this.startTime,
            endTime: this.endTime,
          },
        });
      } else {
        this.boardProjectId = this.formData.projectId;
        this.value2 = this.tempTime;
        this.startTime = this.value2[0];
        this.endTime = this.value2[1];
        this.$router.replace({
          name: name,
          query: {
            projectId: this.formData.projectId,
            startTime: this.startTime,
            endTime: this.endTime,
          },
        });
      }
    },
    setDefaultMonth() {
      const today = new Date();
      // 本月第一天
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      // 本月最后一天
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      end.setHours(23, 59, 59, 999);

      // 格式化为 YYYY-MM-DD
      const format = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
        const day = String(date.getDate()).padStart(2, "0"); // 补零
        return `${year}-${month}-${day}`;
      };
      this.value2 = [format(start), format(end)];
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-range-separator {
  width: 20px;
}

* {
  box-sizing: content-box;
}

.home-map {
  height: 100%;
}

.home-content {
  display: flex;
  flex-direction: column;
  height: calc((100vh - 90px) / 1080 * 100vh);
  margin: -20px;
  padding: 20px;
  background: #eff3f6;

  .home-header {
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .home-body {
    margin-top: 20px;
    flex: 1;
    height: 0;
  }

  .picker {
    width: 280px;
    margin-left: 20px;
    height: 20px;
    line-height: 20px;
  }

  .right {
    width: 144px;
    height: 33px;
    background: #d9e1e7;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    .right-item {
      width: 70px;
      height: 30px;
      background: #d9e1e7;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;

      .right-item-img {
        width: 16px;
        height: 16px;
      }

      i {
        color: #809fb8;
      }

      .span {
        height: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #809fb8;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      &.active {
        border-radius: 8px;
        background: #ffffff;

        i {
          color: #000000;
        }

        .span {
          color: #000000;
        }
      }
    }
  }
}
</style>
